export default __webpack_public_path__ + "static/media/manOnTable.f861b03b.svg";